<template>
  <div class="h-84">
    <div v-for="(skill,index) in feSkills" :key="index">
      <skill
        :img-location="skill.img_location"
        :year-experience="skill.year_experience"
        :rating="skill.rating"
        :heading="skill.heading"
      />
    </div>
  </div>
</template>
<script>
import Skill from "../widget/Skill";
export default {
  components: {
    Skill
  },
  data() {
    return {
      feSkills: [
        {
          heading: "Mysql",
          img_location: "/img/mysql.png",
          year_experience: 2,
          rating: 7.0
        },
        {
          heading: "MongoDb",
          img_location: "/img/mongo.png",
          year_experience: 1,
          rating: 6.0
        }
      ]
    };
  }
};
</script>